// import * as mutations from './mutation-types'
// import { MAKE, OFFER, BUY, EXCHANGE } from './action-types'
import {dbLogs} from '../firebase'

export default {
  newLog ({state}, payload) {
    dbLogs.ref('logs').child('transporter').child(state.authorization.company).push().set(payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js